import { type EmojiResourceConfig } from '@atlaskit/emoji/resource';

const baseEmojiProviderConfig = {
	providers: [
		{
			url: '/gateway/api/emoji/standard',
		},

		{
			url: '/gateway/api/emoji/atlassian',
		},
	],
};

/**
 * @returns A config object for Emoji Service based on the given `cloudId`
 */
export const getEmojiProviderConfig = (cloudId?: string): EmojiResourceConfig => {
	const config = { ...baseEmojiProviderConfig };

	if (cloudId) {
		config.providers = [
			...config.providers,
			{
				url: `/gateway/api/emoji/${cloudId}/site`,
			},
		];
	}

	return config;
};
